import { isLength } from 'validator';
import translation from '@tools/translations/translations';
import TwigFormValidator from '@tools/twig-form/validator';

/**
 * Resetting password component
 */
export default function () {
  const formId = 'user-resetting-password-reset-form';
  if (document.getElementById(formId)) {
    const validator = new TwigFormValidator({
      formSelector: `#${formId}`,
      rules: {
        'resetting_form[plainPassword][first]': [ 'required', (value) => isLength(value, { min: 6 }) ],
        'resetting_form[plainPassword][second]': [ 'required', (value) => value === document.getElementById('resetting_form_plainPassword_second').value ],
      },
      messages: {
        'resetting_form[plainPassword][first]': translation().messages['form.login.error.pwd_short'],
        'resetting_form[plainPassword][second]': translation().messages['form.login.error.pwd_not_identical'],
      },
    });
    validator.init();
  }
}
